
export default function GeographicFocus() {
  return (
    <section className="py-24 lg:py-32 bg-[#F8F7F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
              <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">Service Area</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-6">
              Focused on Texas Data Center Clusters
            </h2>
            <p className="text-lg text-[#5A6670] leading-relaxed mb-6">
              BrightSync supports operators and suppliers serving:
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-[#0A5F5C] rounded-full"></div>
                <span className="text-lg text-[#1A2332] font-medium">Austin data center environments</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-[#0A5F5C] rounded-full"></div>
                <span className="text-lg text-[#1A2332] font-medium">DFW (Dallas–Fort Worth) ecosystems</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-[#0A5F5C] rounded-full"></div>
                <span className="text-lg text-[#1A2332] font-medium">Expanding Texas digital infrastructure corridors</span>
              </div>
            </div>

            <p className="text-[#5A6670] leading-relaxed">
              As Texas scales hyperscale and colocation capacity, readiness predictability becomes increasingly critical.
            </p>
          </div>

          <div className="w-full h-full flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/3bf68d6c09283a962d249fcc9ea91526/adcbd318a6fb9561232fdba47a1a80dd.png"
              alt="Texas Major Cities Map"
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
